// extracted by mini-css-extract-plugin
export default {"pricing-factor-card":"pricing-factor-card--mp-shAkx","pricingFactorCard":"pricing-factor-card--mp-shAkx"};